import axios from "axios";
//import { logout } from "../redux/features/authSlice";
import { clearCart } from "../Containers/DonationView/slice";
import { resetDashBoard } from "../Containers/DashBoardView/slice";
//import store from "../redux/store";
import { createAsyncThunk } from "@reduxjs/toolkit";
import { useDispatch } from 'react-redux';
import { useNavigate } from "react-router-dom";
import { useLoader } from "./LoaderContext";
import { loadProfileFromIndexedDB } from "../storage/profileStorage";
import { removeFromIndexedDB } from "../storage/profileStorage";
const config = {
  baseURL: "https://app.tomaladaca.gov.pt/API/API/",
 //baseURL: "https://app-qua.tomaladaca.gov.pt/API/API/",
  //baseURL: "https://fooddistribution.azurewebsites.net/api/",
  //baseURL: "https://localhost:44361/api/",
   //baseURL: "http://57.153.83.127:8080/api/api/",
  withCredentials: true,
};
//const BASE_URL = "https://app-qua.tomaladaca.gov.pt/API/API/";
const BASE_URL = "https://app.tomaladaca.gov.pt/API/API/";
//const BASE_URL = "https://fooddistribution.azurewebsites.net/api/";
//const BASE_URL= "https://localhost:44361/api/";
 //const BASE_URL =  "http://57.153.83.127:8080/api/api/";
const axiosRoute = axios.create(config);
const defaultToken =
  "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImZha2VAZW1haWwuY29tIiwibmJmIjoxNjY0MTM3NTIwLCJleHAiOjE2NjQyMjM5MjAsImlhdCI6MTY2NDEzNzUyMCwiaXNzIjoibG9jYWxob3N0In0.xEmnGrVFZp7vCdczTYX-prRCzbVySCI8cyYnqcJB0qU";
var userData;
//const {auth: {user: { token}}} = store.getState();


// const parseJwt = (token) => {
//   if (token != null) {
//     const decode = JSON.parse(atob(token.split(".")[1]));
//     console.log("Token Decoded:", decode);

//     // Verifica se o token foi emitido há mais de 3 minutos
//     const tokenIssuedAt = decode.iat * 1000; // Converte para milissegundos
//     const currentTime = new Date().getTime();

//     if (currentTime - tokenIssuedAt > 1 * 60 * 1000) { // 3 minutos em milissegundos
//       console.log("Token expired (3 minutes limit)");
//       handleLogout();
//       throw new Error("Token expired");
//     }

//     return decode;
//   }
// };

const parseJwt = (token) => {
  if (token != null) {
    const decode = JSON.parse(atob(token.split(".")[1]));
    //console.log("Token Decoded:", decode);

    // Verifica se o token foi emitido há mais de 1 hora
    const tokenIssuedAt = decode.iat * 1000; // Converte para milissegundos
    const currentTime = new Date().getTime();

    if (currentTime - tokenIssuedAt > 1 * 60 * 60 * 1000) { // 1 hora em milissegundos
      console.log("Token expired (1 hour limit)");
      handleLogout();
      throw new Error("Token expired");
    }

    return decode;
  }
};

const handleLogout = () => {
  console.log("Logging out...");
  //const dispatch = useDispatch();

  //axiosRoute.post("Registration/logout", data);
  // localStorage.removeItem("userData");
  // localStorage.removeItem("entityProfile");
  localStorage.removeItem("token");
  removeFromIndexedDB("profiles", "entityProfile");
  removeFromIndexedDB("userData", "userData");
  removeFromIndexedDB("entityProfileSelect", "entityProfileSelect");
  window.location.reload();
};

// export const logout = createAsyncThunk(
//   "auth/logout",
//   async function (_payload, thunkAPI) {
//       thunkAPI.dispatch({ type: 'logout/LOGOUT' });
//   }
// );

//export const logout = (data) => axiosRoute.post("Registration/logout", data);

export const register = async (data) =>
  axiosRoute.post("Registration/Registration", data, {
    headers: { Authorization: defaultToken },
  });

export const login = (data) => axiosRoute.post("Registration/login", data);

export const addAddress = async (data, token) =>
  await axiosRoute.post("Registration/AddAddress", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

export const addUserDetail = async (data, token) =>
  await axiosRoute.post("Registration/AddUserDetail", data, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  const triggerLoading = (isLoading) => {
    const event = new CustomEvent("setLoading", { detail: isLoading });
    window.dispatchEvent(event);
  };


  axiosRoute.interceptors.request.use(
    (config) => {
        loadProfileFromIndexedDB((data) => {
            if (!data) {
              return;
            }
            const { profile, user, entityProfile2} = data;
              if(user){
                userData = user ;
              }else{
                //  console.log("Nenhum perfil encontrado.");
              }
      
              
            });
       //const userData = localStorage.getItem('userData');
      
      if (userData) {
        const parsedUserData = JSON.parse(userData);
        const token = parsedUserData.token;
  
        if (token) {
          parseJwt(token);
          config.headers.Authorization = `Bearer ${token}`; 
        }
      }
     if(!config.url.includes("Notification") && !config.url.includes("GetDonationById") && !config.url.includes("GetEntityDetailsById") && !config.url.includes("Registration")){
        triggerLoading(true);
     }
      
      return config; // Retorna a configuração da requisição
    },
    (error) => {
      // Caso haja erro na requisição
      triggerLoading(false);
  
      return Promise.reject(error);
    }
  );


  axiosRoute.interceptors.response.use(
    (response) => {
      if(!response.config.url.includes("AddCollectionInvite")){
        triggerLoading(false);
      }
      // Finaliza o loader após a resposta
     
  
      return response;
    },
    (error) => {
      // Caso haja erro na resposta
      triggerLoading(false);
      return Promise.reject(error);
    }
  );


export const getDataApi = async (url, token) => {
  const myToken = `Bearer ${token}`;
  const res = await axiosRoute.get(BASE_URL + url, {
    headers: {
      Authorization: myToken,
    },
  });
  return res;
};

export const postDataApi = async (url, data, token) => {
  const myToken = `Bearer ${token}`;
  try {
    const res = await axiosRoute.post(BASE_URL + url, data, {
      headers: {
        Authorization: myToken,
      },
    });
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const putDataNoAuthApi = async (url, data, token) => {
  // const myToken = `Bearer ${token}`;
  try {
    const res = await axiosRoute.put(BASE_URL + url, data);
    return res;
  } catch (error) {
    console.log(error);
  }
};

export const putDataApi = async (url, data, token) => {
  const myToken = `Bearer ${token}`;
  const res = await axiosRoute.put(BASE_URL + url, data, {
    headers: {
      Authorization: myToken,
    },
  });
  return res;
};

export const patchDataApi = async (url, data, token) => {
  const myToken = `Bearer ${token}`;
  const res = await axiosRoute.patch(BASE_URL + url, data, {
    headers: {
      Authorization: myToken,
    },
  });
  return res;
};

export const deleteDataApi = async (url, token) => {
  const myToken = `Bearer ${token}`;
  const res = await axiosRoute.delete(BASE_URL + url, {
    headers: {
      Authorization: myToken,
    },
  });
  return res;
};

export const getCollection = async (url, data, token) => {
  const myToken = `Bearer ${token}`;
  const res = await axiosRoute.get(BASE_URL + url, {
    params: {
      ...data,
    },
    headers: {
      Authorization: myToken,
    },
  });
  return res;
};

export const getApi = async (url, params, token) => {
  const myToken = `Bearer ${token}`;
  const res = await axiosRoute.get(BASE_URL + url, {
    params: {
      ...params,
    },
    headers: {
      Authorization: myToken,
    },
  });
  return res;
};

export const postApi = async (url, data, params, token,onUploadProgress) => {
  const myToken = `Bearer ${token}`;
  const res = await axiosRoute.post(BASE_URL + url, data, {
    params: {
      ...params,
    },
    headers: {
      Authorization: myToken,
    },
    onUploadProgress 
  });
  return res;
};


